import { render } from "./Approach.vue?vue&type=template&id=c40ef338"
import script from "./Approach.vue?vue&type=script&lang=js"
export * from "./Approach.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__